import { render } from "./About.vue?vue&type=template&id=43e2a874"
const script = {}

import "./About.vue?vue&type=style&index=0&id=43e2a874&lang=css"

import exportComponent from "D:\\Hobby\\Javascript\\Sito_AS\\aperispeak\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__